import React, { useState } from 'react';
import { Mic, Volume2, CheckCircle2, Star, Play } from 'lucide-react';
import { Header } from '../components/Header.js';
import { EduCard } from '../components/EduCard.js';
import { EduButton } from '../components/EduButton.js';
import { EduBadge } from '../components/EduBadge.js';

export const Voices: React.FC = () => {
  const [voices, setVoices] = useState([
    {
      id: 'faber',
      name: 'Faber (Padrão Oficial)',
      language: 'pt_BR',
      gender: 'Masculino',
      version: 'v1.0.0-medium',
      isDefault: true,
      active: true,
      sampleText: 'Olá! Sou a voz Faber, padrão oficial da plataforma EduRender para videoaulas.',
    },
    {
      id: 'cadu',
      name: 'Cadu',
      language: 'pt_BR',
      gender: 'Masculino',
      version: 'v1.0.0-medium',
      isDefault: false,
      active: true,
      sampleText: 'Olá! Sou o Cadu, voz com cadência didática ideal para cursos técnicos.',
    },
    {
      id: 'jeff',
      name: 'Jeff',
      language: 'pt_BR',
      gender: 'Masculino',
      version: 'v1.0.0-medium',
      isDefault: false,
      active: true,
      sampleText: 'Olá! Sou o Jeff, voz dinâmica para resumos e sínteses pedagógicas.',
    },
  ]);

  const [playingVoiceId, setPlayingVoiceId] = useState<string | null>(null);

  const handleTestVoice = (voiceId: string) => {
    setPlayingVoiceId(voiceId);
    setTimeout(() => {
      setPlayingVoiceId(null);
    }, 2000);
  };

  const handleSetDefault = (voiceId: string) => {
    setVoices(
      voices.map((v) => ({
        ...v,
        isDefault: v.id === voiceId,
      }))
    );
  };

  return (
    <div>
      <Header
        title="Gerenciamento de Vozes (Piper TTS)"
        subtitle="Controle dos modelos neurais de síntese de voz em português brasileiro instalados no servidor Linux"
      />

      <div className="p-8 max-w-7xl mx-auto space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {voices.map((voice) => (
            <EduCard
              key={voice.id}
              title={
                <div className="flex items-center justify-between w-full">
                  <span className="truncate">{voice.name}</span>
                  {voice.isDefault && (
                    <EduBadge variant="orange" size="sm">
                      Padrão
                    </EduBadge>
                  )}
                </div>
              }
              subtitle={`Idioma: ${voice.language} • Gênero: ${voice.gender}`}
              footer={
                <div className="flex items-center justify-between w-full text-xs">
                  {!voice.isDefault ? (
                    <button
                      onClick={() => handleSetDefault(voice.id)}
                      className="text-brand-primary font-semibold hover:underline flex items-center gap-1"
                    >
                      <Star size={13} /> Definir como Padrão
                    </button>
                  ) : (
                    <span className="text-status-success font-semibold flex items-center gap-1">
                      <CheckCircle2 size={13} /> Voz Padrão do Sistema
                    </span>
                  )}
                  <EduButton
                    variant="secondary"
                    size="sm"
                    onClick={() => handleTestVoice(voice.id)}
                    isLoading={playingVoiceId === voice.id}
                    icon={<Volume2 size={13} />}
                  >
                    Testar
                  </EduButton>
                </div>
              }
            >
              <div className="p-3 bg-surface-secondary border border-bdr rounded-lg mb-4 text-xs italic text-txt-secondary">
                "{voice.sampleText}"
              </div>
              <div className="space-y-1.5 text-xs text-txt-secondary">
                <div className="flex justify-between">
                  <span>Versão ONNX:</span>
                  <strong className="text-txt-primary font-mono">{voice.version}</strong>
                </div>
                <div className="flex justify-between">
                  <span>Status no Linux:</span>
                  <EduBadge variant="success" size="sm" dot>Instalado & Validado</EduBadge>
                </div>
              </div>
            </EduCard>
          ))}
        </div>
      </div>
    </div>
  );
};
